exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".article-editor {\n  width: 700px;\n  max-width: 100vw;\n  padding: 16px;\n}\n.article-editor .notice-box {\n  margin-bottom: 16px;\n}\n.article-editor .sub-title {\n  font-size: 12px;\n  font-size: 14px;\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n", ""]);
